import i18next from 'i18next';

import { formatNumberWithCurrency } from '@commons/DisplayNumber';
import utilsXLS from '@commons/utils/makeXLS';

const getExportColumns = () => [
  { name: i18next.t('GENERAL.NAME'), propertyKey: 'name' },
  { name: i18next.t('GENERAL.CATEGORY'), propertyKey: 'category' },
  { name: i18next.t('GENERAL.SUB_CATEGORY'), propertyKey: 'subCategory' },
  { name: i18next.t('GENERAL.PRICE_TTC'), propertyKey: 'priceWithTaxes' },
  {
    name: i18next.t('ADMIN.SUPPLIER_PRODUCTS.MODAL_PROPERTIES_AVAILABLE_ORDER'),
    propertyKey: 'availableStoreCount',
  },
  { name: i18next.t('ADMIN.STORES.LIST_COLUMN_STOCKS'), propertyKey: 'inventoryStoreCount' },
  { name: i18next.t('ADMIN.STORES.LIST_COLUMN_LOSS'), propertyKey: 'lossStoreCount' },
  { name: i18next.t('ADMIN.STORES.LIST_COLUMN_TRANSFER'), propertyKey: 'transferStoreCount' },
];

const formatSupplierProductsForExport = (supplierProducts, currency) =>
  supplierProducts.map(
    ({
      name,
      category,
      subCategory,
      priceWithTaxes,
      suppliedStoreCount,
      availableStoreCount,
      inventoryStoreCount,
      lossStoreCount,
      transferStoreCount,
    }) => ({
      name,
      category,
      subCategory,
      priceWithTaxes: formatNumberWithCurrency({
        number: priceWithTaxes,
        currency,
        displayCurrencyCode: true,
      }),
      availableStoreCount: `${availableStoreCount}/${suppliedStoreCount}`,
      inventoryStoreCount: `${inventoryStoreCount}/${suppliedStoreCount}`,
      lossStoreCount: `${lossStoreCount}/${suppliedStoreCount}`,
      transferStoreCount: `${transferStoreCount}/${suppliedStoreCount}`,
    }),
  );

/**
 * Generate the central products XLS of a central kitchen
 *
 * @param {Object[]} supplierProducts - The supplier products to export
 * @param {Object} currency
 * @param {string} storeName          - The central kitchen name, used in the file name
 */
export const exportCentralProducts = (supplierProducts, currency, storeName) => {
  const title = i18next.t('ADMIN.SUB_FEATURES.CENTRAL_PRODUCTS');

  const sheet = utilsXLS.generateDefaultSheet(
    title,
    getExportColumns(),
    formatSupplierProductsForExport(supplierProducts, currency),
    currency,
  );

  utilsXLS.makeXLS(`${title}_${storeName}`, [sheet]);
};

export default { exportCentralProducts };
